export default __webpack_public_path__ + "static/media/uno.5e910556.svg";